module.exports = __webpack_public_path__ + "img/people_icon.f9747916.jpg";